import queryString from "query-string";
import { PlanIdTypeSafe } from "@/types/PlanTypes";

type QueryWithPlanId = { plan_id: PlanIdTypeSafe } & Record<string, any>;

/**
 * Converts "frontend" plan id to "backend" plan id.
 */
export function toPlanId(plan_id?: PlanIdTypeSafe) {
  if (plan_id === "default") {
    return undefined;
  }

  return plan_id;
}

/**
 * This function ensures that correct plan_id is added to the query string.
 *
 * `default` means we do not pass the plan_id. We want this to be explicit
 * so that we have a type-safety in case we forget to pass the plan_id.
 */
export function urlWithPlanId(
  url: string,
  queryParams: QueryWithPlanId
): string {
  const plan_id = toPlanId(queryParams.plan_id);
  const newQueryParams: Partial<QueryWithPlanId> = { ...queryParams };
  delete newQueryParams.plan_id;

  if (plan_id) {
    newQueryParams.plan_id = plan_id;
  }

  const query = queryString.stringify(newQueryParams);
  if (query) {
    return `${url}?${query}`;
  }
  return url;
}
